import styled, { css, keyframes } from "styled-components";
import { color as colorHelper } from "@m/alchemy-theme";
const loadingRotate = keyframes `
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const loadingDash = keyframes `
  0% {
    stroke-dasharray: 5%, 270%;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dashoffset: -68.75%;
  }
  50%, 100% {
    stroke-dasharray: 206.25%, 270%;
  }
  100% {
    stroke-dashoffset: -270%;
  }
`;
const processingRotate = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
`;
const processingDash = keyframes `
  0% {
    stroke-dashoffset: 0%;
  }
  40% {
    stroke-dashoffset: 540%;
  }
  100% {
    stroke-dashoffset: 0%;
  }
`;
const ie11LoadingRotate = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
export const IE11Loader = styled.div `
  display: inline-block;
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    border: 2px solid
      ${({ hasBackground, color }) => (hasBackground ? colorHelper("inverse") : color ? color : colorHelper("base"))};
    border-radius: 50%;
    animation: ${ie11LoadingRotate} 1.2s linear infinite;
    border-top-color: ${({ hasBackground, color }) => hasBackground ? colorHelper("inverse") : color ? color : colorHelper("base")};
    border-right-color: ${({ hasBackground, color }) => hasBackground ? colorHelper("inverse") : color ? color : colorHelper("base")};
    border-bottom-color: ${({ hasBackground, color }) => hasBackground ? colorHelper("inverse") : color ? color : colorHelper("base")};
    border-left-color: transparent;
  }

  :nth-child(1) {
    animation-delay: -0.45s;
  }
  :nth-child(2) {
    animation-delay: -0.3s;
  }

  :nth-child(3) {
    animation-delay: -0.15s;
  }
`;
export const CircleSvg = styled.svg `
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  ${(props) => props.variant === "determinate" &&
    css `
      animation: ${loadingRotate} 2s linear infinite;
    `}

  ${(props) => props.variant === "indeterminate" &&
    css `
      animation: ${processingRotate} 3s linear infinite;
    `}
`;
export const Circle = styled.circle `
  transform-origin: 50% 50%;
  stroke-dashoffset: 0;
  stroke: ${({ hasBackground, color }) => hasBackground ? colorHelper("inverse") : color ? color : colorHelper("base")};

  ${(props) => props.variant === "determinate" &&
    css `
      stroke-dasharray: 5%, 270%;
      stroke-linecap: round;
      animation: ${loadingDash} 1.5s ease-in-out infinite;
    `}

  ${(props) => props.variant === "indeterminate" &&
    css `
      stroke-dasharray: 270%;
      stroke-linecap: square;
      animation: ${processingDash} 3s ease-in-out infinite;
    `}
`;
export const CircleWrapper = styled.span `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  background-color: ${({ color }) => (color ? color : colorHelper("base"))};

  > ${CircleSvg} {
    display: block;
  }
`;
